<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">List of events</h2>
      </div>
      <button
        @click="addingNewItem"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add Event
      </button>
    </div>
    <!-- filters -->
    <div class="flex flex-col">
      <div class="flex flex-wrap items-center justify-between gap-2">
        <div class="flex bg-gray-200 rounded-lg">
          <button
            :class="[
              'px-4 py-2 font-medium focus:outline-none transition select-none',
              search.eventStatus === '' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
            ]"
            @click="
              search.eventStatus = '';
              fileter('', 'eventStatus');
            "
          >
            All
          </button>
          <button
            :class="[
              'px-4 py-2 font-medium focus:outline-none transition select-none',
              search.eventStatus === 'APPROVED'
                ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10'
                : 'text-gray-600 hover:bg-gray-200',
            ]"
            @click="
              search.eventStatus = 'APPROVED';
              fileter('APPROVED', 'eventStatus');
            "
          >
            Approved
          </button>
          <button
            :class="[
              'px-4 py-2 font-medium focus:outline-none transition select-none',
              search.eventStatus === 'PENDING'
                ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10'
                : 'text-gray-600 hover:bg-gray-200',
            ]"
            @click="
              search.eventStatus = 'PENDING';
              fileter('PENDING', 'eventStatus');
            "
          >
            Pending
          </button>
          <button
            :class="[
              'px-4 py-2 font-medium focus:outline-none transition select-none',
              search.eventStatus === 'REJECTED'
                ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10'
                : 'text-gray-600 hover:bg-gray-200',
            ]"
            @click="
              search.eventStatus = 'REJECTED';
              fileter('REJECTED', 'eventStatus');
            "
          >
            Rejected
          </button>
        </div>
        <div class="flex items-center gap-2">
          <!-- search key -->
          <vs-select @change="fileter($event, 'searchKey', false)" v-model="search.searchKey" class="w-40">
            <vs-select-item value text="Search On" />
            <vs-select-item value="email" text="Email" />
            <vs-select-item value="userName" text="Username" />
            <vs-select-item value="state" text="State" />
            <vs-select-item value="pincode" text="Pincode" />
          </vs-select>
          <!-- search field -->
          <vs-input
            class="w-20"
            icon-after="true"
            label-placeholder="Search by selected parameter"
            icon="search"
            v-model="searchValue"
            style="z-index: 0"
          />
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-between gap-2 mb-4">
        <!--  Search and Sort Controls -->
        <div class="flex items-center gap-2">
          <!-- language search -->
          <vs-select v-model="search.language" @change="fileter($event, 'language')" class="w-24" :color="'#6366f1'">
            <vs-select-item value="" text="All Languages" disabled />
            <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
          </vs-select>
          <!-- category search -->
          <vs-select @change="fileter($event, 'categoryId')" v-model="search.categoryId" class="w-28">
            <vs-select-item value="" text="All Category" />
            <vs-select-item :key="index" :value="item._id" :text="item.categoryName" v-for="(item, index) in categories" />
          </vs-select>
          <!-- sorting search -->
          <vs-select v-model="sorting" @change="fileter($event, 'sorting')" class="w-28" :color="'#6366f1'">
            <vs-select-item :value="1" text="Ascending" />
            <vs-select-item :value="-1" text="Descending" />
          </vs-select>
          <!-- visibility search -->
          <vs-select v-model="search.isPrivate" @change="fileter($event, 'isPrivate')" class="w-28" :color="'#6366f1'">
            <vs-select-item value="" text="All Visibility" />
            <vs-select-item value="false" text="Public" />
            <vs-select-item value="true" text="Private" />
          </vs-select>
          <!-- years search -->
          <vs-select @change="fileter($event, 'year')" v-model="search.year" class="w-24">
            <vs-select-item value="" text="All Years" />
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in years" />
          </vs-select>
          <!-- month search -->
          <vs-select @change="fileter($event, 'month')" v-model="search.month" class="w-28">
            <vs-select-item value="" text="All Months" />
            <vs-select-item v-for="(item, index) in months" :key="index" :value="index + 1" :text="item" />
          </vs-select>
        </div>
        <!-- buttons -->
        <div class="flex items-center gap-2">
          <button
            @click="fetchAllEvents()"
            class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition"
          >
            <span class="material-icons text-base">search</span> Search
          </button>
          <button
            @click="resetData()"
            class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition"
          >
            <span class="material-icons text-base">refresh</span> Reset
          </button>
        </div>
      </div>
    </div>
    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3"></th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Title</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Extra Details</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Status</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Creation Date</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in all" :key="item._id" class="border-b hover:bg-gray-100 transition">
            <td class="px-4 py-3 text-sm text-gray-700">{{ idx + 1 + pagination.per_page * (pagination.current_page - 1) }}</td>
            <td class="px-4 py-2">
              <img :src="item.imageURL || require('@/assets/images/No-image.png')" alt="Event Thumbnail" class="w-28 h-16 object-cover rounded-lg" />
            </td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.title }}</td>
            <td class="px-4 py-1 font-medium text-gray-800 text-center">
              <span class="material-icons" style="cursor: pointer" @click="viewDesc(item)">remove_red_eye</span>
            </td>
            <td class="px-4 py-3 text-sm text-gray-700 text-center">{{ item.language }}</td>
            <td class="px-4 py-1 text-center">
              <div class="flex flex-col gap-2">
                <!-- approval status -->
                <span
                  :class="
                    item.eventStatus === 'APPROVED'
                      ? 'bg-green-500 text-white'
                      : item.eventStatus === 'PENDING'
                      ? 'bg-yellow-500 text-white'
                      : 'bg-gray-200 text-gray-500'
                  "
                  class="inline-block px-3 py-1 rounded-full font-semibold"
                >
                  {{ item.eventStatus }}
                </span>
                <!-- private/public status -->
                <span
                  :class="item.isPrivate ? 'bg-red-500 text-white' : 'bg-blue-500 text-white'"
                  class="inline-block px-3 py-1 rounded-full font-semibold"
                >
                  {{ item.isPrivate ? "Private" : "Public" }}
                </span>
              </div>
            </td>
            <td class="px-4 py-3 text-sm text-gray-700 text-center">{{ formatDate(item.createdAt) }}</td>
            <td class="px-4 py-1">
              <vs-dropdown>
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editingItem(item)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      eventApproval = true;
                      approvalitem = item;
                      isApprove = true;
                    "
                    v-if="item.eventStatus === 'PENDING'"
                  >
                    <vs-icon icon="check_circle" class="align-right" /> Approve
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      eventApproval = true;
                      approvalitem = item;
                      isApprove = false;
                    "
                    v-if="item.eventStatus === 'PENDING'"
                  >
                    <vs-icon icon="cancel" class="align-right" /> Reject
                  </vs-dropdown-item>

                  <vs-dropdown-item
                    @click="
                      deleteEventPopup = true;
                      itemToDelete = item;
                    "
                  >
                    <vs-icon icon="delete_sweep" /> Delete
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      viewUserPopup = true;
                      itemToView = item.usersId;
                    "
                  >
                    <vs-icon icon="visibility" class="align-right" /> View User
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
          <tr v-if="!all || all.length === 0">
            <td colspan="12" class="text-center h-full py-6 text-gray-400">No events found.</td>
          </tr>
        </tbody>
      </table>
      <!-- pagination -->
      <div class="flex flex-col md:flex-row items-center justify-between mt-3 pr-3" v-if="pagination && pagination.total_pages > 1">
        <div class="invisible">
          <span>asd</span>
        </div>
        <div class="flex justify-center items-center">
          <vs-pagination v-model="pagination.current_page" :total="pagination.total_pages" :limit="1" @change="fetchAllEvents" class="my-2" />
        </div>
        <div class="flex items-center gap-2 text-sm mt-2 md:mt-0">
          <span>Show Records:</span>
          <vs-select v-model="pagination.per_page" @change="fetchAllEvents(1)" class="w-20" :color="'#6366f1'">
            <vs-select-item value="10" text="10" />
            <vs-select-item value="25" text="25" />
            <vs-select-item value="50" text="50" />
          </vs-select>
        </div>
      </div>
    </div>

    <!-- add/edit Event Popup -->
    <vs-popup :title="isNew ? 'Add New Event' : 'Edit Event'" :active.sync="defaultalert">
      <div class="px-2 flex flex-col gap-1">
        <!-- category selection -->
        <div class="w-1/4">
          <label class="block text-sm font-semibold mb-2"> Category*</label>
          <vs-select v-model="event.categoryId" :color="'#6366f1'">
            <vs-select-item :key="index" :value="item._id" :text="item.categoryName" v-for="(item, index) in categories" />
          </vs-select>
        </div>
        <!-- event title -->
        <label class="block text-sm font-semibold">Event Title*</label>
        <div class="flex items-center gap-2">
          <vs-input v-model="event.title" @input="onEventTitleInput" placeholder="Keep short and simple" class="w-full" required />
          <button
            type="button"
            @click="geminiAutofill"
            :disabled="!event.title || autofillDone || autofillLoading"
            class="flex items-center gap-1 px-3 py-2 rounded-lg font-semibold text-sm transition whitespace-nowrap"
            :class="[
              !event.title || autofillDone || autofillLoading
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-purple-600 hover:bg-purple-700 text-white',
            ]"
          >
            <span class="material-icons text-sm">{{ autofillLoading ? 'hourglass_empty' : 'search' }}</span>
            {{ autofillLoading ? 'Searching...' : autofillDone ? 'Searched' : 'Search' }}
          </button>
        </div>
        <!-- event description -->
        <label class="block text-sm font-semibold">Event Description*</label>
        <vs-textarea v-model="event.description" placeholder="Keep short and simple" class="w-full" required />
        <!-- event image upload -->
        <div class="flex-1" style="height: 150px">
          <div class="flex justify-between items-start">
            <label class="block text-sm font-semibold">Image</label>
            <button
              v-if="displayImage"
              type="button"
              color="danger"
              class="bg-red-500 p-1 h-6 rounded-md hover:bg-red-700 transition text-white"
              @click="clearImage"
            >
              Clear
            </button>
          </div>
          <div
            class="flex flex-col items-center justify-center border-2 border-dashed rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
            style="width: 100%; height: 140px; min-height: 140px"
            @dragover.prevent
            @dragenter.prevent
            @drop.prevent="onDropImage"
            @click="triggerFileInput"
          >
            <img v-if="displayImage" :src="displayImage" class="rounded-md object-cover border" style="width: 200px; max-height: 140px" />
            <div v-else class="flex flex-col items-center justify-center w-full h-full text-gray-400">
              <span class="material-icons" style="font-size: 32px">cloud_upload</span>
              <span>Drag & Drop or Click to Upload</span>
            </div>
            <input type="file" ref="fileInput" class="hidden" @change="onImageChange" accept="image/jpeg,image/jpg,image/webp" />
          </div>
        </div>
        <!-- flex boxed phone + user email -->
        <div class="flex justify-between w-full gap-2 mt-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">User Email*</label>
            <vs-input v-model="event.email" placeholder="Enter user email" class="w-full" required />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Phone*</label>
            <vs-input v-model="event.phone" placeholder="Enter phone number" class="w-full" required />
          </div>
        </div>
        <!-- address -->
        <label class="block text-sm font-semibold">Event Address</label>
        <!-- <vue-google-autocomplete
          id="map"
          class="w-full"
          placeholder="Start typing to search for address"
          :types="['address']"
          :country="['in']"
          @placechanged="getAddressData"
        /> -->
        <vs-input v-model="event.address" placeholder="Enter event address" class="w-full" required />
        <!-- flexed boxed city + taluka -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">City*</label>
            <vs-input v-model="event.city" placeholder="Enter city" class="w-full" required />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">District*</label>
            <vs-input v-model="event.districtName" placeholder="Enter district" class="w-full" required />
          </div>
        </div>
        <!-- flexed boxed district +  state -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Taluk*</label>
            <vs-input v-model="event.talukName" placeholder="Enter taluk" class="w-full" required />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Duration*</label>
            <vs-input v-model.number="event.duration" class="w-full" required type="number" />
          </div>
          <!-- <div class="w-1/2">
            <label class="block text-sm font-semibold">Country*</label>
            <vs-input v-model="event.country" placeholder="Enter country" class="w-full" required />
          </div> -->
        </div>
        <!-- flexed boxed pincode + user limit -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Pincode*</label>
            <vs-input v-model.number="event.pincode" class="w-full" required type="number" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">User Limit*</label>
            <vs-input v-model.number="event.userLimit" class="w-full" required type="number" :min="1" />
          </div>
        </div>
        <!-- flexed boxed latitude + longitude  -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Latitude*</label>
            <vs-input v-model.number="event.location.coordinates[0]" class="w-full" required type="number" step="any" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Longitude*</label>
            <vs-input v-model.number="event.location.coordinates[1]" class="w-full" required type="number" step="any" />
          </div>
        </div>
        <!-- flexed date in -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-full">
            <label class="block text-sm font-semibold">Start Date*</label>
            <datepicker v-model="event.startDate" :format="'yyyy/MM/dd'" input-class="border" class="w-full" required />
          </div>
          <div class="w-full">
            <label class="block text-sm font-semibold">End Date*</label>
            <datepicker v-model="event.endDate" :format="'yyyy/MM/dd'" input-class="border" class="w-full" required />
          </div>
        </div>
        <!-- flexed time in -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-full">
            <label class="block text-sm font-semibold">Start Time*</label>
            <vue-timepicker v-model="event.startTime" format="HH:mm" class="w-full" required />
          </div>
          <div class="w-full">
            <label class="block text-sm font-semibold">End Time*</label>
            <vue-timepicker v-model="event.endTime" format="HH:mm" class="w-full" required />
          </div>
        </div>
        <!-- flexed boxed in one row recurring, feature event, private, status togglepills -->
        <div class="flex justify-between w-full gap-1">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Recurring</label>
            <toggle-pill label="Recurring" v-model="event.isRecurring" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Feature Event</label>
            <toggle-pill label="Feature Event" v-model="event.feature" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Private</label>
            <toggle-pill label="Private" v-model="event.isPrivate" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Status</label>
            <toggle-pill label="Status (Active/Inactive)" v-model="event.status" />
          </div>
        </div>
        <!-- if feature event  show flexed boxed alltime + district + taluk + town-->
        <div class="flex justify-between w-full gap-1" v-if="event.feature">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">All Time</label>
            <toggle-pill label="All Time" v-model="event.alltime" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">District</label>
            <toggle-pill label="District" v-model="event.district" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Taluk</label>
            <toggle-pill label="Taluk" v-model="event.taluk" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Town</label>
            <toggle-pill label="Town" v-model="event.town" />
          </div>
        </div>
        <!-- attachment  -->
        <div class="upload-btn-wrapper vs-input-primary">
          <label class="vs-input--label">Attachment</label>
          <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload an Attachment File</div>
          <input type="file" ref="fileInput2" @change="uploadImage($event, true)" />
        </div>
        <!-- attachments -->
        <div class="mr-2" v-for="(url, index) in event.attachments" :key="index" v-if="event.attachments.length > 0">
          <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteattachmentImage(index)"></vs-button>
          <img
            :src="url.fileurl"
            class="imgUp"
            height="100px"
            width="150px"
            v-if="url.filetype == 'image/jpeg' || url.filetype == 'image/png' || url.filetype == 'image/jpg'"
          />
          <vs-icon icon="assignment" @click="openDoc(url.fileurl)" v-if="url.filetype == 'application/pdf'" class="icon-medium pointer"> </vs-icon>
          <audio controls v-if="url.filetype == 'audio/mpeg'">
            <source :src="url.url" type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </div>
      </div>
      <div class="flex flex-col md:flex-row gap-2 mt-8">
        <vs-button :loading="showLoader" color="primary" type="filled" class="flex-1" @click="btnAddEvent">
          {{ isNew ? "Save Event" : "Update Event" }}
        </vs-button>
      </div>
    </vs-popup>

    <!-- Delete Confirmation Popup -->
    <vs-popup title="Delete Event" :active.sync="deleteEventPopup">
      <p class="mb-4 text-lg text-gray-700">Are you sure you want to delete this event?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="confirmDeleteEvent">Delete</vs-button>
        <vs-button color="primary" @click="deleteEventPopup = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <!-- approval/rejection confirmation popup -->
    <vs-popup :title="isApprove ? 'Event Approval' : 'Event Rejection'" :active.sync="eventApproval">
      <p v-if="isApprove">Are you sure you want to Approve {{ approvalitem.title }} Event?</p>
      <p v-else>Are you sure you want to Reject {{ approvalitem.title }} Event?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="eventApprovalFunction">
          {{ isApprove ? "Approve" : "Reject" }}
        </vs-button>
        <vs-button color="primary" @click="eventApproval = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <!-- View Description Modal-->
    <vs-popup title="Event Details" :active.sync="viewDescPopup">
      <div class="px-2 flex flex-col" v-if="viewDescPopup">
        <label class="block text-sm font-semibold">Title:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.title ? viewDescItem.title : "N/A" }}</p>

        <label class="block text-sm font-semibold">Description:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.description ? viewDescItem.description : "N/A" }}</p>

        <label class="block text-sm font-semibold">Category:</label>
        <p class="text-gray-700">
          {{ viewDescItem && viewDescItem.categoryId ? viewDescItem.categoryId.categoryName : "N/A" }}
        </p>

        <label class="block text-sm font-semibold">Event Status:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.eventStatus ? viewDescItem.eventStatus : "N/A" }}</p>

        <label class="block text-sm font-semibold">Start Date & Time:</label>
        <p class="text-gray-700">
          {{
            viewDescItem && viewDescItem.startDate
              ? new Date(viewDescItem.startDate).toLocaleDateString() + " " + (viewDescItem.startTime || "N/A")
              : "N/A"
          }}
        </p>

        <label class="block text-sm font-semibold">End Date & Time:</label>
        <p class="text-gray-700">
          {{
            viewDescItem && viewDescItem.endDate ? new Date(viewDescItem.endDate).toLocaleDateString() + " " + (viewDescItem.endTime || "N/A") : "N/A"
          }}
        </p>

        <label class="block text-sm font-semibold">Location:</label>
        <p class="text-gray-700">
          {{
            viewDescItem && viewDescItem.address
              ? viewDescItem.address +
                (viewDescItem.city ? ", " + viewDescItem.city : "") +
                (viewDescItem.districtName ? ", " + viewDescItem.districtName : "") +
                (viewDescItem.talukName ? ", " + viewDescItem.talukName : "") +
                (viewDescItem.state ? ", " + viewDescItem.state : "") +
                (viewDescItem.country ? ", " + viewDescItem.country : "") +
                (viewDescItem.pincode ? " - " + viewDescItem.pincode : "")
              : "N/A"
          }}
        </p>
        <span>
          <p class="text-gray-700">
            Lat: {{ viewDescItem && viewDescItem.location && viewDescItem.location.coordinates ? viewDescItem.location.coordinates[0] : "N/A" }}
          </p>
          <p class="text-gray-700">
            Lng: {{ viewDescItem && viewDescItem.location && viewDescItem.location.coordinates ? viewDescItem.location.coordinates[1] : "N/A" }}
          </p>
        </span>

        <label class="block text-sm font-semibold">User Limit:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.userLimit ? viewDescItem.userLimit : "N/A" }}</p>

        <label class="block text-sm font-semibold">Is Private:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.isPrivate ? "Yes" : "No" }}</p>

        <label class="block text-sm font-semibold">Duration:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.duration ? viewDescItem.duration : "N/A" }}</p>

        <label class="block text-sm font-semibold">View Count:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.viewCount ? viewDescItem.viewCount : "N/A" }}</p>

        <label class="block text-sm font-semibold">Is Recurring:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.isRecurring ? "Yes" : "No" }}</p>

        <label class="block text-sm font-semibold">Feature:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.feature ? "Yes" : "No" }}</p>

        <label class="block text-sm font-semibold">Calendar Type:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.calendarType ? viewDescItem.calendarType : "N/A" }}</p>

        <label class="block text-sm font-semibold">Verified Event:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.verifiedEvent ? "Yes" : "No" }}</p>

        <label class="block text-sm font-semibold">Attending:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.attending ? viewDescItem.attending : "N/A" }}</p>

        <label class="block text-sm font-semibold">Invited:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.invited ? viewDescItem.invited : "N/A" }}</p>

        <label class="block text-sm font-semibold">Not Attending:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.notAttending ? viewDescItem.notAttending : "N/A" }}</p>

        <label class="block text-sm font-semibold">May Be Attending:</label>
        <p class="text-gray-700">{{ viewDescItem && viewDescItem.mayBeAttending ? viewDescItem.mayBeAttending : "N/A" }}</p>

        <label class="block text-sm font-semibold">Attachments:</label>
        <div v-if="viewDescItem && viewDescItem.attachments && viewDescItem.attachments.length">
          <ul>
            <li v-for="attachment in viewDescItem.attachments" :key="attachment._id">
              <a :href="attachment.fileurl" target="_blank">{{ attachment.filetype }}</a>
            </li>
          </ul>
        </div>
        <p v-else class="text-gray-700">No Attachments</p>

        <label class="block text-sm font-semibold">User Details:</label>
        <p class="text-gray-700">
          Name: {{ viewDescItem && viewDescItem.usersId && viewDescItem.usersId.firstName ? viewDescItem.usersId.firstName : "N/A" }}
          {{ viewDescItem && viewDescItem.usersId && viewDescItem.usersId.lastName ? viewDescItem.usersId.lastName : "N/A" }}
        </p>
        <p class="text-gray-700">
          Email: {{ viewDescItem && viewDescItem.usersId && viewDescItem.usersId.userEmail ? viewDescItem.usersId.userEmail : "N/A" }}
        </p>
        <p class="text-gray-700">
          Phone: {{ viewDescItem && viewDescItem.usersId && viewDescItem.usersId.userMob ? viewDescItem.usersId.userMob : "N/A" }}
        </p>
        <p class="text-gray-700">City: {{ viewDescItem && viewDescItem.usersId && viewDescItem.usersId.city ? viewDescItem.usersId.city : "N/A" }}</p>
        <p class="text-gray-700">
          Followers: {{ viewDescItem && viewDescItem.usersId && viewDescItem.usersId.followers ? viewDescItem.usersId.followers.length : 0 }}
        </p>
        <p class="text-gray-700">
          Followings: {{ viewDescItem && viewDescItem.usersId && viewDescItem.usersId.followings ? viewDescItem.usersId.followings.length : 0 }}
        </p>
      </div>
    </vs-popup>

    <!-- User Modal-->
    <vs-popup class="holamundo user-info" title="View User" :active.sync="viewUserPopup">
      <vs-row>
        <vs-col vs-lg="6" vs-xs="6">
          User Information
          <div class="mt-4">
            <img v-if="!itemToView || !itemToView.imageURL" :src="require('@/assets/images/No-image.png')" height="50px" width="75px" />
            <img v-else :src="itemToView.imageURL" height="50px" width="75px" />
            <br />

            <label> {{ itemToView && itemToView.userName ? itemToView.userName : "N/A" }}</label
            ><br />
            <label
              >{{ itemToView && itemToView.firstName ? itemToView.firstName : "N/A" }}
              {{ itemToView && itemToView.lastName ? itemToView.lastName : "N/A" }}</label
            ><br />
            <label>FacebookId : {{ itemToView && itemToView.facebookId ? itemToView.facebookId : "N/A" }}</label
            ><br />
            <label>Mobile Number : {{ itemToView && itemToView.userMob ? itemToView.userMob : "N/A" }}</label
            ><br />
            <label>Email : {{ itemToView && itemToView.userEmail ? itemToView.userEmail : "N/A" }}</label
            ><br />
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="6">
          User Address
          <div class="mt-4">
            <label>City : {{ itemToView && itemToView.city ? itemToView.city : "N/A" }}</label
            ><br />
            <label>Country : {{ itemToView && itemToView.country ? itemToView.country : "N/A" }}</label
            ><br />
            <label>Birth Date : {{ itemToView && itemToView.birthday ? new Date(itemToView.birthday).toLocaleString() : "N/A" }}</label
            ><br />
            <label>isBanned : {{ itemToView && itemToView.isBanned ? "Yes" : "No" }}</label
            ><br />
            <label>isVerified : {{ itemToView && itemToView.isVerified ? "Yes" : "No" }}</label
            ><br />
            <label>isPrivateProfile : {{ itemToView && itemToView.isPrivateProfile ? "Yes" : "No" }}</label
            ><br />
            <label>VIP User : {{ itemToView && itemToView.vipUser ? "Yes" : "No" }}</label>
          </div>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import api from "@/rest.js";
import Datepicker from "vuejs-datepicker";
import { API } from "@/common/constants";
import "vue2-datepicker/index.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import moment from "moment";
import TogglePill from "../components/Common/TogglePill.vue";

export default {
  name: "Events",
  components: {
    Datepicker,
    VueTimepicker,
    VueGoogleAutocomplete,
    TogglePill,
  },
  data: () => ({
    EventData: [],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    all: [],
    searchValue: "",
    languages: [],
    categories: [],
    years: [],
    isNew: true,
    defaultalert: false,
    deleteEventPopup: false,
    eventApproval: false,
    isApprove: false,
    pagination: {
      current_page: 1,
      per_page: 10,
      total_count: 0,
      total_pages: 1,
    },
    currentPage: 1,
    pageSize: 10,
    sortDirection: "asc",
    sorting: -1,
    displayImage: "",
    search: {
      sort: 1,
      language: "EN",
      status: "0",
      isPrivate: "",
      isVerified: "",
      searchKey: "",
      categoryId: "",
      eventStatus: "",
      year: "",
      month: "",
    },
    event: {
      email: "",
      language: "",
      title: "",
      description: "",
      phone: "",
      name: "",
      city: "",
      talukName: "",
      districtName: "",
      country: "",
      imageURL: "",
      categoryId: "",
      location: { type: "Point", coordinates: [] },
      startTime: "",
      endTime: "",
      usersId: "",
      address: "",
      attachments: [],
      feature: false,
      alltime: false,
      district: false,
      taluk: false,
      town: false,
      isRecurring: true,
    },
    itemToDelete: "",
    approvalitem: "",
    itemToView: "",
    showLoader: false,
    autofillLoading: false,
    autofillDone: false,
    lastAutofillTitle: "",
    viewUserPopup: false,
    viewDescPopup: false,
    viewDescItem: {},
  }),
  methods: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },

    viewDesc(item) {
      this.viewDescPopup = true;
      this.viewDescItem = item;
    },

    async resetData() {
      this.$data.search = {
        sort: 1,
        status: "0",
        language: "",
        isBanned: "",
        isVerified: "",
        searchKey: "",
        categoryId: "",
        isPrivate: "",
        sorting: -1,
        eventStatus: "",
        year: "",
        month: "",
      };
      this.$data.searchValue = "";
      await this.fetchAllEvents();
    },

    openDoc(url) {
      window.open(url, "_blank");
    },

    // getAddressData(data) {
    //   if (document.getElementById("map")) this.$data.event.address = document.getElementById("map").value;

    //   this.$data.event.location.coordinates = [data.longitude, data.latitude];
    //   this.$data.event.pincode = data.postal_code ? data.postal_code : "";
    //   this.$data.event.city = data.locality ? data.locality : data.administrative_area_level_2;
    //   this.$data.event.state = data.administrative_area_level_1;
    // },

    deleteattachmentImage(item) {
      if (item > -1) {
        this.$data.event.attachments.splice(item, 1);
      }
    },

    addingNewItem() {
      this.clearImage();
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.displayImage = "";
      this.$data.autofillDone = false;
      this.$data.lastAutofillTitle = "";
      this.$data.event = {
        email: "",
        language: "",
        title: "",
        description: "",
        phone: "",
        name: "",
        city: "",
        country: "",
        imageURL: "",
        categoryId: "",
        location: { type: "Point", coordinates: [] },
        startTime: "",
        endTime: "",
        usersId: "",
        address: "",
        attachments: [],
        feature: false,
        alltime: false,
        district: false,
        taluk: false,
        town: false,
        talukName: "",
        districtName: "",
      };
      if (this.$route.query.addNew) this.$router.replace({ query: null });
    },

    editingItem(i) {
      this.$data.event = { ...i };
      if (i.categoryId && i.categoryId._id) this.$data.event["categoryId"] = i.categoryId._id;
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage = i.imageURL || "";
      this.$data.autofillDone = false;
      this.$data.lastAutofillTitle = "";
    },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.event.imageURL = file;
        this.displayImage = URL.createObjectURL(file);
      }
    },

    clearImage() {
      this.displayImage = "";
      this.event.imageURL = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    onDropImage(e) {
      const files = e.dataTransfer.files;
      if (files && files[0]) {
        this.onImageChange({ target: { files } });
      }
    },

    async uploadImage(data, attachments = false) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      try {
        let formdata = new FormData();
        this.$data.fileName = data.target.files[0].name;
        formdata.append("file", data.target.files[0]);

        const response = await api.post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response && response.status === 200) {
          if (!attachments) this.$data.event.imageURL = response.data.files[0].url;
          else
            this.$data.event.attachments.push({
              filetype: response.data.files[0].fileType,
              fileurl: response.data.files[0].url,
            });

          this.$vs.notify({
            text: "File Uploaded",
            color: "success",
            position: "top-right",
          });

          this.$refs.fileInput.value = null;
          if (attachments) this.$refs.fileInput2.value = null;
          this.$emit("input", data);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "There was an error uploading the file.",
          color: "danger",
          position: "top-right",
        });
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllCategory() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_EVENT_CAT, {});
        if (r.status === 200) this.$data.categories = r.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async filter(event, param, flag = true) {
      this.$data.search[param] = event;
      this.$data.currentPage = 1;
      if (flag) {
        await this.fetchAllEvents(this.$data.currentPage);
      }
    },

    fileter(event, param, flag = true) {
      this.$data.search[param] = event;
      this.$data.currentPage = 1;
      if (flag) {
        this.fetchAllEvents(this.$data.currentPage);
      }
    },

    async fetchAllEvents(page) {
      this.$vs.loading();

      try {
        const r = await api.get(API.GET_EVENT, {
          params: {
            pageNumber: page,
            pageSize: this.$data.pagination.per_page || 10,
            sort: this.$data.search.sort,
            language: this.$data.search.language,
            searchKey: this.$data.search.searchKey,
            searchValue: this.$data.searchValue,
            categoryId: this.$data.search.categoryId,
            isPrivate: this.$data.search.isPrivate,
            status: this.$data.search.status,
            sortOrder: this.$data.sorting,
            eventStatus: this.$data.search.eventStatus,
            year: this.$data.search.year,
            month: this.$data.search.month,
            sortBy: "createdAt",
          },
        });

        if (r.status === 200) {
          this.$data.all = r.data.data.data;

          if (this.EventData && Object.keys(this.EventData).length > 0) {
            this.all[0] = this.EventData;
          }

          if (this.$route.query.edit === "true" || this.$route.query.editFromDashboard === "true") {
            // const targetId = this.$route.query.id;
            // const targetItem = this.all.find((item) => item._id === targetId);
            // if (targetItem) {
            //   this.editingItem(targetItem, "edit");
            // }
            if (this.$route.query.editFromDashboard === "true") {
              const queryParams = { ...this.$route.query };
              delete queryParams.editFromDashboard;

              if (this.$router.currentRoute.fullPath !== this.$router.resolve({ query: queryParams }).href)
                this.$router.replace({ query: queryParams });
            }
          }

          r.data.data.meta.pagination.current_page = parseInt(r.data.data.meta.pagination.current_page);

          this.$data.pagination = r.data.data.meta.pagination;
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching events",
          color: "danger",
          position: "top-right",
        });
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async btnAddEvent() {
      if (
        !this.$data.event.endDate ||
        !this.$data.event.startDate ||
        !this.$data.event.title ||
        !this.$data.event.description ||
        !this.$data.event.endTime ||
        !this.$data.event.startTime ||
        !this.$data.event.categoryId ||
        // !this.$data.event.imageURL ||
        !this.$data.event.city ||
        !this.$data.event.talukName ||
        !this.$data.event.districtName ||
        !this.$data.event.email
      ) {
        this.$vs.notify({
          text: "Please enter all the details",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      try {
        this.$data.event.usersId = JSON.parse(localStorage.user)._id;

        const findCategory = this.$data.categories.find((item) => item._id === this.$data.event.categoryId);
        this.$data.event.language = this.$data.search.language ? this.$data.search.language : findCategory.language;

        // this.$data.event.location.coordinates[0] = parseFloat(this.$data.event.location.coordinates[0]);
        // this.$data.event.location.coordinates[1] = parseFloat(this.$data.event.location.coordinates[1]);

        this.$data.event.location.coordinates[0] = parseFloat(parseFloat(this.$data.event.location.coordinates[0]).toFixed(6));
        this.$data.event.location.coordinates[1] = parseFloat(parseFloat(this.$data.event.location.coordinates[1]).toFixed(6));

        if (this.$data.event.imageURL && this.$data.event.imageURL instanceof File)
          await this.uploadImage({ target: { files: [this.$data.event.imageURL] } });

        if (!this.$data.isNew) {
          if (typeof this.$data.event.startTime == "object") {
            this.$data.event.startTime = this.$data.event.startTime.hh + ":" + this.$data.event.startTime.mm;
          }
          if (typeof this.$data.event.endTime == "object") {
            this.$data.event.endTime = this.$data.event.endTime.hh + ":" + this.$data.event.endTime.mm;
          }

          let date = new Date(this.$data.event.startDate);
          let eDate = new Date(this.$data.event.endDate);

          if (this.$data.event.startDate) {
            this.$data.event.startDate = date.getFullYear() + "/" + this.padTo2Digits(date.getMonth() + 1) + "/" + this.padTo2Digits(date.getDate());
          }

          if (this.$data.event.endDate) {
            this.$data.event.endDate = eDate.getFullYear() + "/" + this.padTo2Digits(eDate.getMonth() + 1) + "/" + this.padTo2Digits(eDate.getDate());
          }

          await this.btnUpdateEvent();
        } else {
          let data = this.$data.event;
          let fieldName = "";
          if (data.language == "") {
            fieldName = "Language";
          }

          if (!data.feature) {
            data.alltime = false;
            data.district = false;
            data.taluk = false;
            data.town = false;
          } else {
            if (!data.alltime && !data.district && !data.taluk && !data.town) {
              this.$vs.notify({
                text: "Please select feature type",
                color: "danger",
                position: "top-right",
              });
              return;
            }
          }

          const r = await api.post(API.GET_EVENT, data);

          if (r.status === 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.itemToDelete = "";
            this.$data.itemToView = "";
            this.$data.defaultalert = false;
            await this.fetchAllEvents(this.$data.currentPage);
          }
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error saving/updating event",
          color: "danger",
          position: "top-right",
        });
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async btnUpdateEvent() {
      this.$vs.loading();
      try {
        if (this.$route.query.id) this.$router.replace({ path: "/events", query: { id: this.$route.query.id, edit: "false" } });

        if (
          !this.$data.event.endDate ||
          !this.$data.event.startDate ||
          !this.$data.event.title ||
          !this.$data.event.description ||
          !this.$data.event.address ||
          !this.$data.event.endTime ||
          !this.$data.event.startTime ||
          !this.$data.event.categoryId ||
          !this.$data.event.city ||
          !this.$data.event.talukName ||
          !this.$data.event.districtName ||
          !this.$data.event.email
        ) {
          this.$vs.notify({
            text: "Please enter all the details",
            color: "danger",
            position: "top-right",
          });
          return;
        }

        let data = this.$data.event;
        // this.$data.event.location.coordinates[0] = parseFloat(this.$data.event.location.coordinates[0]);
        // this.$data.event.location.coordinates[1] = parseFloat(this.$data.event.location.coordinates[1]);
        if (data.startDate) {
          let date = new Date(data.startDate);
          data.startDate = date.getFullYear() + "-" + this.padTo2Digits(date.getMonth() + 1) + "-" + this.padTo2Digits(date.getDate());
        }

        if (data.endDate) {
          let date = new Date(data.endDate);
          data.endDate = date.getFullYear() + "-" + this.padTo2Digits(date.getMonth() + 1) + "-" + this.padTo2Digits(date.getDate());
        }

        let id = this.$data.event._id;

        if (!data.feature) {
          data.alltime = false;
          data.district = false;
          data.taluk = false;
          data.town = false;
        } else {
          if (!data.alltime && !data.district && !data.taluk && !data.town) {
            this.$vs.notify({
              text: "Please select feature type",
              color: "danger",
              position: "top-right",
            });
            return;
          }
        }

        const r = await api.put(API.GET_EVENT, data, { params: { id: id } });

        if (r.status == 200) {
          this.$vs.notify({
            text: "Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.itemToDelete = "";
          this.$data.itemToView = "";
          this.$data.defaultalert = false;

          // if (this.$route.query.id) await this.fetchEvent(this.$route.query.id);

          await this.fetchAllEvents(this.$data.currentPage);
          if (this.$route.query.id && this.$route.query.edit === "false") {
            this.$router.push({ path: "/calendar" });
          }
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error updating event",
          color: "danger",
          position: "top-right",
        });
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async confirmDeleteEvent() {
      let id = this.$data.itemToDelete._id;
      try {
        const r = await api.delete(API.GET_EVENT, { params: { id: id } });
        if (r.status == 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
        }
        this.$data.deleteEventPopup = false;
        await this.fetchAllEvents(this.$data.currentPage);
      } catch (error) {
        this.$vs.notify({
          text: "Error deleting event",
          color: "danger",
          position: "top-right",
        });
        console.error("Failed to delete event:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async eventApprovalFunction() {
      let id = this.$data.approvalitem._id;

      try {
        const r = await api.post(API.GET_EVENT + "/review", {
          eventStatus: this.$data.isApprove ? "APPROVED" : "REJECTED",
          id: id,
        });

        if (r.status == 200) {
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          this.$data.eventApproval = false;
          this.$data.approvalitem = "";
          await this.fetchAllEvents(this.$data.currentPage);
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error updating event status",
          color: "danger",
          position: "top-right",
        });
        console.error("Failed to update event status:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchEvent(id) {
      try {
        const response = await api.get(`${API.SOCIAL_EVENTS}/${id}`);
        if (response.status === 200) this.editingItem(response.data);
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching event details",
          color: "danger",
          position: "top-right",
        });
        console.error("Failed to fetch event details:", error);
      }
    },

    onEventTitleInput() {
      if (this.event.title !== this.lastAutofillTitle) {
        this.autofillDone = false;
      }
    },

    async geminiAutofill() {
      if (!this.event.title || this.autofillDone || this.autofillLoading) return;

      this.autofillLoading = true;
      try {
        const response = await api.get("/ai/geminiEventAutofill", {
          params: { query: this.event.title },
        });

        const raw = response.data;
        const data = raw && raw.data !== undefined ? raw.data : raw;

        if (!data) {
          this.$vs.notify({
            title: "AI Search",
            text: "No data found for this event.",
            color: "warning",
            position: "top-right",
            time: 6000,
          });
          return;
        }

        const filledFields = [];

        const fieldMap = [
          { apiKey: "short_description", eventKey: "description", label: "Description" },
          { apiKey: "user_email", eventKey: "email", label: "User Email" },
          { apiKey: "phone", eventKey: "phone", label: "Phone" },
          { apiKey: "event_address", eventKey: "address", label: "Event Address" },
          { apiKey: "city", eventKey: "city", label: "City" },
          { apiKey: "district", eventKey: "districtName", label: "District" },
          { apiKey: "taluk", eventKey: "talukName", label: "Taluk" },
          { apiKey: "pincode", eventKey: "pincode", label: "Pincode" },
          { apiKey: "user_limit", eventKey: "userLimit", label: "User Limit" },
        ];

        fieldMap.forEach(({ apiKey, eventKey, label }) => {
          if (data[apiKey] !== null && data[apiKey] !== undefined && data[apiKey] !== "") {
            this.event[eventKey] = data[apiKey];
            filledFields.push(label);
          }
        });

        // Duration: extract numeric value (API may return "3 Days" or a number)
        if (data.duration !== null && data.duration !== undefined && data.duration !== "") {
          const numDuration = typeof data.duration === "number" ? data.duration : parseInt(data.duration);
          if (!isNaN(numDuration)) {
            this.event.duration = numDuration;
            filledFields.push("Duration");
          }
        }

        // Coordinates (use $set for reactivity on array indices)
        if (data.latitude !== null && data.latitude !== undefined) {
          this.$set(this.event.location.coordinates, 0, data.latitude);
          filledFields.push("Latitude");
        }
        if (data.longitude !== null && data.longitude !== undefined) {
          this.$set(this.event.location.coordinates, 1, data.longitude);
          filledFields.push("Longitude");
        }

        // Dates: convert ISO string to Date object for datepicker
        if (data.start_date !== null && data.start_date !== undefined && data.start_date !== "") {
          this.event.startDate = new Date(data.start_date);
          filledFields.push("Start Date");
        }
        if (data.end_date !== null && data.end_date !== undefined && data.end_date !== "") {
          this.event.endDate = new Date(data.end_date);
          filledFields.push("End Date");
        }

        this.lastAutofillTitle = this.event.title;
        this.autofillDone = true;

        if (filledFields.length > 0) {
          this.$vs.notify({
            title: "Autofill Complete",
            text: "Fields filled: " + filledFields.join(", "),
            color: "success",
            position: "top-right",
            time: 10000,
          });
        } else {
          this.$vs.notify({
            title: "AI Search",
            text: "No matching data found for this event.",
            color: "warning",
            position: "top-right",
            time: 6000,
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Search Error",
          text: "Failed to fetch event details. Please try again.",
          color: "danger",
          position: "top-right",
        });
        console.error("Gemini autofill error:", error);
      } finally {
        this.autofillLoading = false;
      }
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await Promise.all([this.fetchAllLanguages(), this.fetchAllEvents(this.$data.currentPage), this.fetchAllCategory()]);
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year > 2020; year--) {
      this.$data.years.push(year);
    }
    if (this.$route.query.id) await this.fetchEvent(this.$route.query.id);

    if (this.$route.query.addNew === "true") this.addingNewItem();
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
